export enum Role {
    ADMIN = 'ADMIN',
    SHIFTLEAD = 'SHIFTLEAD',
    MONITOR = 'MONITOR'
}
